<script setup>
import { computed } from 'vue'
import { useBatchStore } from '@/stores/BatchStore'
import { Tooltip } from 'flowbite-vue'
import SetLockIndicatorContent from '@/components/SetLockIndicator/SetLockIndicatorContent.vue'

const props = defineProps({
  hideSettingsText: { type: Boolean, default: false },
  useTooltip: { type: Boolean, default: false }
})

const batchStore = useBatchStore()

const setLockedTitles = computed(() => {
  if (batchStore.selectedBatch?.locked_sets?.length) {
    return batchStore.selectedBatch?.locked_sets?.map(set => set.collx_set_name).join(', ')
  } else if (batchStore.selectedBatch?.lock_id) {
    return batchStore.selectedBatch?.lock_name
  }
})

const handleEditInSettings = () => {
  batchStore.openBatchSettings = true
}
</script>
<template>
  <div class="flex items-center gap-x-2 w-full min-w-0 prevent-click-outside">
    <div class="flex items-center gap-x-2 rounded-lg py-1 px-2 border border-gray-200 bg-gray-200 flex-none">
      <Icon icon="heroicons:lock-closed-16-solid" class="text-gray-500 w-4 h-4" />
      <span class="text-gray-500 text-sm font-medium whitespace-nowrap">Set Locked</span>
    </div> 
    <span v-if="!useTooltip" class="text-gray-400 text-xs font-medium truncate flex-1 min-w-0">{{ setLockedTitles }}</span>
    <template v-else>
      <div class="flex-1 min-w-0 overflow-hidden">
        <Tooltip trigger="click" placement="bottom-start" theme="light">
          <template #trigger>
            <span class="text-gray-400 text-xs font-medium truncate block cursor-pointer hover:text-gray-600 prevent-click-outside">{{ setLockedTitles }}</span>
          </template>
          <template #content>
            <SetLockIndicatorContent @editInSettings="handleEditInSettings" />
          </template>
        </Tooltip>
      </div>
      <span class="text-gray-400 text-xs font-medium flex-none">...</span>
    </template>
    <div class="flex items-center gap-x-2 cursor-pointer flex-none" @click="handleEditInSettings">
      <Icon icon="heroicons:cog-8-tooth" class="text-tint-1 w-4 h-4" />
      <span v-if="!hideSettingsText" class="text-tint-1 text-xs font-medium">Edit in Settings</span>
    </div>
  </div>
</template>